export class Sidebar {
  constructor(sidebarId, overlayId) {
    this.node = document.getElementById(sidebarId);
    this.overlay = document.getElementById(overlayId);
    this.closeBtn = this.node?.querySelector('.sidebar-c-basis__close-btn');
    this.scrollPosition = 0;
    this.previouslyFocused = null;
    this.mainContent = document.querySelector('#MainContent');

    // Bind methods so references are stable for add/removeEventListener
    this.show = this.show.bind(this);
    this.close = this.close.bind(this);
  }

  /**
   * Open Sidebar
   */
  show() {
    this.previouslyFocused = document.activeElement;
    this.scrollPosition = window.scrollY;
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.classList.add('body-no-scroll');

    if (this.mainContent) {
      Array.from(this.mainContent.children).forEach((child) => {
        if (!child.contains(this.node)) {
          child.setAttribute('inert', '');
        } else if (child !== this.node) {
          // The sidebar is nested inside this wrapper (e.g. Shopify section div).
          // Set inert on sibling elements within the wrapper, excluding sidebar and overlay.
          Array.from(child.children).forEach((sibling) => {
            if (sibling !== this.node && sibling !== this.overlay) {
              sibling.setAttribute('inert', '');
            }
          });
        }
      });
    }

    if (this.node) this.node.classList.add('show');

    if (this.overlay) {
      this.overlay.classList.add('show');
    }

    if (this.closeBtn) this.closeBtn.focus();
  }

  /**
   * Close Sidebar
   */
  close() {
    if (this.mainContent) {
      this.mainContent.querySelectorAll('[inert]').forEach((el) => {
        el.removeAttribute('inert');
      });
    }

    document.body.classList.remove('body-no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, this.scrollPosition);

    if (this.node) this.node.classList.remove('show');

    if (this.overlay) {
      this.overlay.classList.remove('show');
    }

    if (this.previouslyFocused) {
      this.previouslyFocused.focus();
      this.previouslyFocused = null;
    }
  }

  /**
   * Set event listeners for closing the sidebar
   * @param {function} callback - function to execute after sidebar closes
   */
  setClose(callback = () => {}) {
    this.closeBtn?.addEventListener('click', () => {
      this.close();
      callback();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close);
    }

    this.node.querySelector('[aria-label="close"]')?.addEventListener('click', () => {
      this.close();
      callback();
    });
  }
}
